module.exports = __webpack_public_path__ + "img/bell_black.52d5ef58.svg";